<template>
  <div class="relative w-full h-full pt-[1.2rem]">
    <div class="relative flex flex-col h-full">
      <!-- title -->
      <img :src="`/images/title-${lang}.png`" class="w-[22rem] center-horizontal" />
      <!-- toggle -->
      <div class="toggle relative shrink-0 w-[16rem] mt-[1.5rem] h-[3rem] p-[0.2rem] center-horizontal bg-[#fbfaf8] rounded-full flex justify-center items-center">
        <div @click="change('day')" class="relative rounded-l-full text-left w-[50%] h-full flex justify-between items-center px-[1rem]" :style="{ backgroundColor: type == 'day' ? '#907d4e' : '' }">
          <img class="w-[1rem]" :src="`images/icon-day${type == 'day' ? '-active' : ''}.png`" />
          <p class="w-full text-center uppercase mt-[0.2rem] text-[1rem]">{{ text.day }}</p>
        </div>
        <div @click="change('night')" class="relative rounded-r-full text-right right-0 w-[50%] h-full flex justify-between items-center px-[1rem]" :style="{ backgroundColor: type == 'night' ? '#907d4e' : '' }">
          <p class="w-full text-center uppercase mt-[0.2rem] text-[1rem]">{{ text.night }}</p>
          <img class="w-[1rem]" :src="`images/icon-night${type == 'night' ? '-active' : ''}.png`" />
        </div>
      </div>
      <!-- products -->
      <div class="relative h-full mt-[1rem] mb-[5.7rem] flex-1">
        <div class="relative h-full">
          <!-- products day -->
          <div class="absolute w-full top-0 h-full overflow-y-scroll overflow-x-hidden items-scroll" ref="dayEl">
            <div class="flex flex-col justify-center items-center relative top-[20px] w-full" ref="dayItemsContainerEl">
              <div class="relative my-[-0.6rem] top-0 w-[6rem] h-[6rem] flex justify-center items-center" v-for="(value, index) in productsDay" :key="index" ref="dayItemsEl">
                <!-- product img -->
                <img :src="`images/${value.img}`" class="relative w-[5.5rem] productImg" />
                <div class="absolute mt-[-1rem] w-[10rem] productLabel flex flex-col gap-[0.3rem]">
                  <!-- product name -->
                  <p class="text-[1.4rem] text-[white] font-[cronos-d-light] uppercase mt-[0.2rem] leading-[1] w-full">{{ value.name }}</p>
                  <!-- play btn -->
                  <div v-if="value.usage" class="videoBtn relative bg-[#907d4e] w-fit px-[0.25rem] py-[0.2rem] rounded-[0.9rem] flex justify-center items-center" @click="playBtnClicked(value.name, value.usage)">
                    <p class="text-white font-[cronos] text-[0.8rem] px-[0.9rem]">{{ videosLoaded[value.usage.videoIndex] ? "HOW TO USE" : "LOADING..." }}</p>
                    <img src="/images/btn-play.png" class="w-[1.3rem] font-[cronos]" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- products night -->
          <div class="absolute w-full top-0 h-full overflow-y-scroll overflow-x-hidden items-scroll" ref="nightEl">
            <div class="flex flex-col justify-center items-center relative top-[20px] w-full" ref="nightItemsContainerEl">
              <div class="relative my-[-0.6rem] top-0 w-[6rem] h-[6rem] flex justify-center items-center" v-for="(value, index) in productsNight" :key="index" ref="nightItemsEl">
                <!-- product img -->
                <img :src="`images/${value.img}`" class="relative w-[5.5rem] productImg" />
                <div class="absolute mt-[-1rem] w-[10rem] productLabel flex flex-col gap-[0.3rem]">
                  <!-- product name -->
                  <p class="text-[1.4rem] text-[white] font-[cronos-d-light] uppercase mt-[0.2rem] leading-[1] w-full">{{ value.name }}</p>
                  <!-- play btn -->
                  <div v-if="value.usage" class="videoBtn relative bg-[#907d4e] w-fit px-[0.25rem] py-[0.2rem] rounded-[0.9rem] flex justify-center items-center" @click="playBtnClicked(value.name, value.usage)">
                    <p class="text-white font-[cronos] text-[0.8rem] px-[0.9rem]">{{ value.usage.type == "image" || videosLoaded[value.usage.videoIndex] ? "HOW TO USE" : "LOADING..." }}</p>
                    <img src="/images/btn-play.png" class="w-[1.3rem] font-[cronos]" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end -->
        </div>
      </div>
      <!-- open website btn -->
      <div class="absolute bottom-[2rem] bg-[#907d4e] w-fit center-horizontal rounded-[0.3rem]" @click="openTab()">
        <p class="px-[1rem] py-[0.8rem] uppercase text-white text-[1.1rem] tracking-[0.05rem]">Visit Our Website</p>
      </div>
    </div>

    <!-- video modal -->
    <div class="modal flex flex-col" ref="videoModalEl">
      <img class="relative w-[3rem]" src="/images/btn-close.png" @click="closeModal('video')" />
      <p class="text-[#b8a26d] uppercase font-[cronos-d-light] text-[1.5rem] mt-[1rem] mb-[-0.4rem]">{{ currentProduct }}</p>
      <div class="relative w-full mt-[1.5rem]">
        <VideoComp v-show="currentVideo == index" v-for="(video, index) in allVideos" :key="index" :url="video" :poster="'howToUse.png'" :ref="`video${index}El`" @loaded="handleVideoLoaded(index)" />
      </div>
    </div>

    <!-- image modal -->
    <div class="modal flex flex-col" ref="imageModalEl">
      <img class="relative w-[3rem]" src="/images/btn-close.png" @click="closeModal('image')" />
      <p class="text-[#b8a26d] uppercase font-[cronos-d-light] text-[1.5rem] mt-[1rem] mb-[-0.4rem]">{{ currentProduct }}</p>
      <div class="relative mt-[0.3rem]">
        <Carousel :images="showImages" ref="carouselEl" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";
import VideoComp from "./components/Videos.vue";
import Carousel from "./components/Carousel.vue";

export default {
  name: "App",
  components: { VideoComp, Carousel },
  data() {
    return {
      type: "day",
      name: "",
      productsDay: [
        { id: 1, name: "soap", img: "day/product-1.png", usage: { type: "video", videoIndex: 0 } },
        { id: 2, name: "lotion", img: "day/product-2.png", usage: { type: "video", videoIndex: 1 } },
        { id: 3, name: "eye cream", img: "day/product-3.png", usage: { type: "video", videoIndex: 2 } },
        { id: 4, name: "daytime moisturizers", img: "day/product-4.png", usage: { type: "video", videoIndex: 3 } },
        { id: 5, name: "neck cream", img: "day/product-5.png", usage: { type: "video", videoIndex: 5 } },
        { id: 6, name: "rose synactif", img: "day/product-6.png" },
      ],
      productsNight: [
        { id: 1, name: "soap", img: "night/product-1.png", usage: { type: "video", videoIndex: 0 } },
        { id: 2, name: "lotion", img: "night/product-2.png", usage: { type: "video", videoIndex: 1 } },
        { id: 3, name: "nighttime moisturizer", img: "night/product-3.png", usage: { type: "video", videoIndex: 3 } },
        { id: 4, name: "cream", img: "night/product-4.png", usage: { type: "video", videoIndex: 4 } },
        { id: 5, name: "eye cream", img: "night/product-5.png", usage: { type: "video", videoIndex: 2 } },
        { id: 6, name: "eye mask", img: "night/product-6.png", usage: { type: "image", images: ["image-1.png", "image-2.png", "image-3.png"] } },
        { id: 7, name: "neck cream", img: "night/product-7.png", usage: { type: "video", videoIndex: 5 } },
        { id: 8, name: "body cream", img: "night/product-8.png", usage: { type: "video", videoIndex: 6 } },
        { id: 9, name: "rose synactif", img: "night/product-9.png" },
      ],
      lang: "en",
      text: {},
      currentProduct: "",
      currentVideo: "",
      showImages: ["image-1.png", "image-2.png", "image-3.png"],
      allVideos: [
        "Core6_Soap_HowToUse.mp4",
        "Core6_Lotion_HowToUse.mp4",
        "Core6_EyeCream_HowToUse.mp4",
        "Core6_Mois_HowToUse.mp4",
        "Core6_Cream_HowToUse.mp4",
        "Specialists_NeckCream_HowToUse.mp4",
        "Specialists_BodyCream_HowToUse.mp4",
      ],
      videosLoaded: [],
    };
  },
  methods: {
    openTab() {
      window.open("https://www.cledepeau-beaute.com", "_blank");
    },
    change(type) {
      gsap.to(this.$refs[`${this.type}El`], { autoAlpha: 0, duration: 0.3, ease: "power2.out" });
      gsap.to(this.$refs[`${type}El`], { autoAlpha: 1, duration: 0.3, ease: "power2.out" });
      this.type = type;
    },
    resize() {
      var width = window.innerWidth > 300 ? window.innerWidth : 300;
      var height = window.innerHeight > 500 ? window.innerHeight : 500;
      var widthRatio = width / 375;
      var heightRatio = height / 667;
      var newFontSize;

      if (widthRatio < heightRatio) {
        newFontSize = 12 * widthRatio;
      } else {
        newFontSize = 12 * heightRatio;
      }

      document.documentElement.style.fontSize = newFontSize + "px";
      // this.displayDeviceType();
    },
    toggleTab(type) {
      if (type == "show") {
        gsap.to(this.$refs.showTabEl, { xPercent: 0, ease: "expo.out", duration: 0.5 });
        gsap.to(this.$refs.hideTabEl, { xPercent: 100, ease: "expo.out", duration: 0.5 });
      } else {
        gsap.to(this.$refs.showTabEl, { xPercent: 100, ease: "expo.out", duration: 0.5 });
        gsap.to(this.$refs.hideTabEl, { xPercent: 0, ease: "expo.out", duration: 0.5 });
      }
    },
    playBtnClicked(name, usage) {
      if (usage.type == "video" && this.videosLoaded[usage.videoIndex] === undefined) return;

      console.log("play btn clicked", name, usage);
      this.currentProduct = name;
      if (usage.type == "video") {
        this.currentVideo = usage.videoIndex;
        this.$nextTick(() => {
          this.$refs[`video${usage.videoIndex}El`][0].start();
          gsap.set(this.$refs.videoModalEl, { autoAlpha: 1 });
        });
      } else if (usage.type == "image") {
        this.showImages = usage.images;
        gsap.set(this.$refs.imageModalEl, { autoAlpha: 1 });
      }
    },
    handleVideoLoaded(index) {
      this.videosLoaded[index] = true;
      console.log("video loaded", index);
    },
    closeModal(type) {
      console.log("close modal", this.currentVideo);
      if (type === "video") {
        gsap.set(this.$refs.videoModalEl, { autoAlpha: 0 });
        this.$refs[`video${this.currentVideo}El`][0].reset();
        this.currentVideo = 0;
      } else if (type === "image") {
        gsap.set(this.$refs.imageModalEl, { autoAlpha: 0 });
        this.$refs.carouselEl.reset();
      }
      this.currentProduct = "";
    },
    async importFonts() {
      import(`./assets/css/style-${this.lang}.css`);
      this.text = (await import(`./assets/text-${this.lang}.json`)).default;
    },
    async setLang() {
      let params = new URLSearchParams(window.location.search);
      const lang = params.get("lang");

      this.lang = lang ? lang : "en";
      await this.importFonts();

      this.$nextTick(() => {
        ["day", "night"].forEach((type) => {
          const items = this.$refs[`${type}ItemsEl`];

          if (!items) return;
          for (let i = 0; i < items.length; i++) {
            const el = items[i];
            const text = el.querySelector(".productLabel");
            const img = el.querySelector(".productImg");
            const videoBtn = el.querySelector(".videoBtn");

            if (i % 2 == 0) {
              gsap.set(el, { x: "-1.9rem" });
              gsap.set(text, { textAlign: "right", right: "6.4rem", left: "unset", alignItems: "end" });
              if (videoBtn) gsap.set(videoBtn, { marginRight: "-0.2rem" });
            } else {
              gsap.set(el, { x: "1.9rem" });
              gsap.set(text, { textAlign: "left", left: "6.4rem", right: "unset", alignItems: "start" });
              if (videoBtn) gsap.set(videoBtn, { marginLeft: "-0.2rem" });
            }
          }
        });
      });
    },
  },
  mounted() {
    this.setLang();
    this.resize();
    gsap.set(this.$refs.videoModalEl, { autoAlpha: 0 });
    gsap.set(this.$refs.imageModalEl, { autoAlpha: 0 });
    gsap.set(this.$refs.nightEl, { autoAlpha: 0 });
    window.addEventListener("resize", this.resize, true);
  },
};
</script>

<style>
html,
body {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  font-size: 12px;
  font-family: "cronos";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
}
#app {
  text-align: center;
  background-image: url("./../public/images/bg.png");
  background-size: cover;
  background-position: top;
  position: relative;
  width: 100%;
  height: 100%;
}
@media (orientation: landscape) {
  #app {
    background-image: url("./../public/images/bg2.png");
  }
}
.center-horizontal {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
}
.overflow-y-scroll::-webkit-scrollbar {
  display: none !important;
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
</style>
